import gql from 'graphql-tag';

export type AccessPoint = {
  id: string;
  accessPointID: string;
  status: string;
  isActive: boolean;
  submitTimestamp: string | null;
  identificationSuccess: boolean | null;
  identificationTries: number | null;
  identificationSuccessTimestamp: string | null;
  openingHours: OpeningHours | null;
  idFront: Photo | null;
  idBack: Photo | null;
  idSelfie: Photo | null;
  createdAt: string;
  updatedAt: string;
  dropPoint: DropPoint;
};

export type DropPoint = {
  id: string;
  isActive: boolean;
  locationName: string;
  accessPointDataMigrated: boolean | null;
  pickupTimes: PickupTime[];
  submitTimestamp: string | null;
  identificationSuccess: boolean | null;
  identificationTries: number | null;
  identificationSuccessTimestamp: string | null;
  openingHours: OpeningHours | null;
  idFront: Photo | null;
  idBack: Photo | null;
  idSelfie: Photo | null;
  user: User;
  address: Address;
  createdAt: string;
  hubCounter?: {
    id: string;
    status: string;
  } | null;
};

export type PickupTime = {
  from: number;
  to: number;
  weekday?: number | null;
  allDays?: boolean | null;
};

export type OpeningHours = {
  type: string;
  monday: TimeRange[];
  tuesday: TimeRange[];
  wednesday: TimeRange[];
  thursday: TimeRange[];
  friday: TimeRange[];
  saturday: TimeRange[];
  sunday: TimeRange[];
};

export type TimeRange = {
  from: string;
  to: string;
};

export type Photo = {
  uri: string;
};

export type Address = {
  street: string;
  houseNumber: string;
  postalCode: string;
  city: string;
};

export type User = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
};

export type AccessPointsQuery = {
  accessPoints: AccessPoint[];
};

export const GET_ACCESS_POINTS = gql`
  query GET_ACCESS_POINTS($status: [AccessPointStatus!]!) {
    accessPoints(status: $status) {
      id
      accessPointID
      status
      isActive

      submitTimestamp
      identificationSuccess
      identificationTries
      identificationSuccessTimestamp
      openingHours {
        type
        monday {
          from
          to
        }
        tuesday {
          from
          to
        }
        wednesday {
          from
          to
        }
        thursday {
          from
          to
        }
        friday {
          from
          to
        }
        saturday {
          from
          to
        }
        sunday {
          from
          to
        }
      }
      idFront {
        uri
      }
      idBack {
        uri
      }
      idSelfie {
        uri
      }

      createdAt
      updatedAt
      dropPoint {
        id
        isActive
        locationName
        createdAt
        accessPointDataMigrated
        pickupTimes {
          from
          to
          weekday
          allDays
        }
        submitTimestamp
        identificationSuccess
        identificationTries
        identificationSuccessTimestamp
        openingHours {
          type
          monday {
            from
            to
          }
          tuesday {
            from
            to
          }
          wednesday {
            from
            to
          }
          thursday {
            from
            to
          }
          friday {
            from
            to
          }
          saturday {
            from
            to
          }
          sunday {
            from
            to
          }
        }
        idFront {
          uri
        }
        idBack {
          uri
        }
        idSelfie {
          uri
        }
        address {
          street
          houseNumber
          postalCode
          city
        }
        user {
          id
          firstName
          lastName
          email
        }
        hubCounter {
          id
          status
        }
      }
    }
  }
`;

export const EXPORT_UPS_ACCESS_POINTS_CSV = gql`
  mutation EXPORT_UPS_ACCESS_POINTS_CSV {
    exportUPSAccessPointsCSV
  }
`;
